import { createIcon } from '../createIcon.tsx';

export const RectangleStackIcon = createIcon(
	'RectangleStackIcon',
	<>
		<rect x="2" y="6" width="20" height="12" rx="2" />
		<path d="M6 2h12" />
		<path d="M6 22h12" />
	</>,
);
